import { QueryClient, type VueQueryPluginOptions } from '@tanstack/vue-query';

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      gcTime: 1000 * 60 * 60 * 1,
      staleTime: 1000 * 60 * 5,
    },
  },
});

export const vueQueryOptions = {
  enableDevtoolsV6Plugin: true,
  queryClient: queryClient,
  //TODO: Client persister is disabled for now
  /*clientPersister: (queryClient: QueryClient) => {
    return persistQueryClient({
      queryClient: queryClient as any,
      maxAge: 1000 * 60 * 60 * 1, // 1 hours
      dehydrateOptions: {
        shouldDehydrateQuery: (query) => {
          return (query.meta?.persist ?? false) as boolean;
        },
      },
      persister: createAsyncStoragePersister({
        storage: newIdbStorage(createStore('query', 'client')),
        throttleTime: 0,
      }),
    });
  },*/
} satisfies VueQueryPluginOptions;
